/*
 * @version: 1.0
 * @Author: 杨慢慢
 * @Date: 2022-11-10 10:53:27
 */
import request from '@/utils/request'


export function checkNetworkType(params) {
  return request({
    url: `/wechat/isNetworkType`,
    method: 'GET',
    params
  })
}

//授权
export async function authorize(scope, redirectUri, state) {
  const p = {
      scope,
      redirectUri: import.meta.env.VITE_REDIRECT_URI.startsWith('http') ? import.meta.env.VITE_REDIRECT_URI + redirectUri :
      window.location.origin + (import.meta.env.VITE_REDIRECT_URI.endsWith('/') ? import.meta.env.VITE_REDIRECT_URI.slice(0, -1) : import.meta.env.VITE_REDIRECT_URI)
       + redirectUri,
      state
    }
  console.error('redirectUri', redirectUri,window.location.origin,import.meta.env.VITE_REDIRECT_URI)
  console.error('p', p)
  const res = await request({
    url: `/wechatLogin/author/authorize`,
    method: 'GET',
    params: p
  })
  console.error('res', res)
  return res
}

//登录
export function loginApi(params) {
  return request({
    url: `/login`,
    method: 'POST',
    params
  })
}

//忘记密码
export function forgetPassword(params) {
  return request({
    url: `wechat/forgetPassword/rePassword`,
    method: 'POST',
    data: params
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/wechat/loginData',
    method: 'GET'
  })
}

// 传递session
export function getCookies(session) {
  return request({
    url: 'wechatLogin/author/sessionToCookie?sessionId=' + session,
    method: 'GET'
  })
}

// 添加手机号码
export function getPhone(params) {
  return request({
    // url:"/wechat/setting/modifyPhone",
    url: 'wechat/setting/mergeMobile',
    method: 'POST',
    data: params
  })
}

// 获取验证码
export function getPhoneCode(params) {
  return request({
    url: `/sendNote?phone=${params.phone}&code=${params.code}`,
    method: 'GET'
  })
}

// 新获取验证码
export function getPhoneCodeNew(data) {
  return request({
    url: `/note/pwd?phone=${data.phone}&code=${data.code}&password=${data.password}`,
    method: 'post',
    data
  })
}

// 企业微信api鉴权
export function getAuthorization(url) {
  return request({
    url: '/wechat/setting/config',
    method: 'POST',
    data: url
  })
}

// 钉钉api鉴权
export function getDingtalkAuthentication(data) {
  return request({
    url: '',
    method: 'POST',
    data: {url}
  })
}

// 查看企业权限
export function getStatus(params) {
  return request({
    url: '/qys/enterprise/auth/status',
    method: 'GET',
    params
  })
}

//配置后台校验
export function personalCheck(params, envConfig = {}) {
  return request({
    url: `/wechat/personal/check`,
    method: 'GET',
    params,
    baseURL: envConfig?.intranet === 1 ? envConfig.personalAppUrl : process.env.VITE_API_BASE_URL
  })
}

//配置后台校验
export function checkNote(params) {
  return request({
    url: '/wechat/forgetPassword/checkNote',
    method: 'GET',
    params
  })
}


//获取枚举
export function getEnums(params) {
  return request({
    url: '/enums',
    method: 'GET',
    params
  })
}
// 获取全局登录配置
export function getGlobalLoginType(params) {
  return request({
    url: '/global/login_type',
    method: 'GET',
    params
  })
}